import { frontendURL } from '../../../helper/URLHelper';
import CampanhasView from './pages/CampanhasView.vue';
const meta = { permissions: ['administrator', 'agent'] };
export const routes = [
  { path: frontendURL('accounts/:accountId/campanhas'), name: 'campaigns_index', component: CampanhasView, meta },
];
